const i18n = {
    zh_tw: {
        alert: {
            auth_fail: '您的憑證已過期或者憑證異常, 請重新登入',
            login_success: '登入成功',
            login_fail: '登入失敗',
        },
        login: {
            title: 'INNOLUX 2FA QRCode 查詢系統',
            username: '帳號',
            password: '密碼',
            username_placeholder: 'AD帳號 或 工號 或 廠商帳號',
            password_placeholder: '密碼',
            login_button: '登 入',
        },
        logout: {
            button: '登 出',
        },
        otp: {
            title: '掃描您的 QRCode',
            subTitle: '請使用 2FA APP 掃描以下 QRCode(依照您需要的系統) 並儲存，如無 APP 者請點選下載',
        },
    },
    en_us: {
        alert: {
            auth_fail: 'Your credentials have expired or are invalid. Please log in again!',
            login_success: 'Login Success',
            login_fail: 'Login Fail',
        },
        login: {
            title: 'INNOLUX 2FA QRCode Query System',
            username: 'Account',
            password: 'Password',
            username_placeholder: 'AD Account or Employee ID or Vendor Account',
            password_placeholder: 'Password',
            login_button: 'Sign In',
        },
        logout: {
            button: 'Sign Out',
        },
        otp: {
            title: 'Scan your QRCode',
            subTitle: "Please use a 2FA app to scan the following QRcode and save it. If you don't have the app, please click to download.",
        },
    },
};

export const getLangString = (lang = '') => {
    let c = lang.toLowerCase();
    return i18n[c] ? i18n[c] : i18n['zh_tw'];
};
